/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FacilityStatistics = {
    properties: {
        company: {
    type: 'CompanyStatistics',
    isRequired: true,
},
        departments: {
    type: 'array',
    contains: {
        type: 'SubStatistics',
    },
    isRequired: true,
},
    },
};